import React from "react";
import { DataRequestDetail } from "../../../../common/models";

import { EventList } from "../DataRequestEventList";
import { NoWorkflowRequestSteps } from "./steps/NoWorkflowRequestSteps";
import { ObjectionRequestSteps as ObjectionAndPipedaWithdrawConsentRequestSteps } from "./steps/ObjectionRequestSteps";
import { PortabilityRequestSteps } from "./steps/PortabilityRequestSteps";
import { RectificationRequestSteps } from "./steps/RectificationRequestSteps";
import { RequestToDeleteSteps } from "./steps/RequestToDeleteSteps";
import { RequestToKnowSteps } from "./steps/RequestToKnowSteps";
import { RequestToOptOutSteps } from "./steps/RequestToOptOutSteps";
import { WithdrawConsentRequestSteps } from "./steps/WithdrawConsentRequestSteps";
import { RequestToWithdrawUSConsentSteps } from "./steps/RequestToWithdrawUSConsentSteps";
import { RequestToLimitSteps } from "./steps/RequestToLimitSteps";
import { RequestToProfilingOptOutSteps } from "./steps/RequestToProfilingOptOutSteps";
import { RestrictProcessingSteps } from "./steps/RequestToRestrictProcessingSteps";
import { AppealSteps } from "./steps/AppealSteps";
import { ProfilingInformationSteps } from "./steps/ProfilingInformationSteps";

type Props = {
  request: DataRequestDetail;
};

export const DataRequestBody: React.FC<Props> = ({ request }) => {
  if (request.state == "CLOSED") {
    return <EventList request={request} reverse={true} />;
  }

  switch (request.dataRequestType.workflowType) {
    case "DELETE":
      return <RequestToDeleteSteps request={request} />;
    case "OPT_OUT":
      return <RequestToOptOutSteps request={request} />;
    case "KNOW":
      return <RequestToKnowSteps request={request} />;
    case "PORTABILITY":
      return <PortabilityRequestSteps request={request} />;
    case "CORRECTION":
      return <RectificationRequestSteps request={request} />;
    case "PIPEDA_WITHDRAW_CONSENT":
    case "OBJECTION":
      return <ObjectionAndPipedaWithdrawConsentRequestSteps request={request} />;
    case "RESTRICT_PROCESSING":
      return <RestrictProcessingSteps request={request} />;
    case "WITHDRAW_CONSENT":
      return <WithdrawConsentRequestSteps request={request} />;
    case "US_WITHDRAW_CONSENT":
      return <RequestToWithdrawUSConsentSteps request={request} />;
    case "LIMIT":
      return <RequestToLimitSteps request={request} />;
    case "PROFILING_OPT_OUT":
      return <RequestToProfilingOptOutSteps request={request} />;
    case "APPEAL":
      return <AppealSteps request={request} />;
    case "PROFILING_INFORMATION":
      return <ProfilingInformationSteps request={request} />;
    case "GPC_OPT_OUT":
    case "BROWSER_OPT_OUT":
    default:
      return <NoWorkflowRequestSteps request={request} />;
  }
};
